import { apiRequest } from '@/core';
import { type UpdateEventMatchScorePayload } from '@/slices/events/types';
import { type EventMatchScore } from '@/types';

export const updateEventMatchScoreRequest = async ({
  eventId,
  home_score,
  away_score,
  time,
  status,
}: UpdateEventMatchScorePayload) =>
  apiRequest<EventMatchScore>({
    endpoint: `api/events/${eventId}/match-score`,
    method: 'PATCH',
    body: {
      home_score,
      away_score,
      time,
      status,
    },
  });
